export const NOTIFICATION_THEME_VALUES = {
  COL_MAX_SIZE: 12,
  INPUT_COL_SIZE: 5,
};
